import React from "react";
import {
  vypocitajInvesticnuKalkulacku,
} from "../../utils/investKal.js";

const TRIEDY_AKTIV = [
  {
    kluc: "akcie",
    nazov: "Akcie",
    farba:
      "var(--invest-aktiv-akcie)",
  },
  {
    kluc: "dlhopisy",
    nazov: "Dlhopisy",
    farba:
      "var(--invest-aktiv-dlhopisy)",
  },
  {
    kluc: "penazne",
    nazov: "Peňažné",
    farba:
      "var(--invest-aktiv-penazne)",
  },
  {
    kluc: "zmiesane",
    nazov: "Zmiešané",
    farba:
      "var(--invest-aktiv-zmiesane)",
  },
  {
    kluc: "komodity",
    nazov: "Komodity",
    farba:
      "var(--invest-aktiv-komodity)",
  },
  {
    kluc: "realitne",
    nazov: "Realitné",
    farba:
      "var(--invest-aktiv-realitne)",
  },
  {
    kluc: "alternativne",
    nazov: "Alternatívne",
    farba:
      "var(--invest-aktiv-alternativne)",
  },
];

const cislo = (hodnota) => {
  const vysledok = Number(hodnota);

  return Number.isFinite(vysledok)
    ? vysledok
    : 0;
};

const formatujMena = (hodnota) =>
  cislo(hodnota).toLocaleString(
    "sk-SK",
    {
      maximumFractionDigits: 0,
    }
  );

function formatujRozdelenuMenu(
  hodnota
) {
  return cislo(hodnota).toLocaleString(
    "sk-SK",
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }
  );
}

const VLASTNA_VOLBA_KLUC =
  "vlastnaVolba";

function vytvorKlucProduktu(kod) {
  return `produkt:${kod}`;
}

function rozdelSumuPodlaVah(
  polozky,
  suma
) {
  const sumaVCentoch = Math.round(
    cislo(suma) * 100
  );

  let rozdeleneCenty = 0;

  return polozky.reduce(
    (
      vysledok,
      polozka,
      index
    ) => {
      const jePosledna =
        index ===
        polozky.length - 1;

      const centy = jePosledna
        ? sumaVCentoch -
          rozdeleneCenty
        : Math.round(
            sumaVCentoch *
              (
                cislo(
                  polozka.vaha
                ) / 100
              )
          );

      rozdeleneCenty += centy;

      vysledok[polozka.kluc] =
        centy / 100;

      return vysledok;
    },
    {}
  );
}

function zistiCelkovyHorizont(
  aktivnyVariant
) {
  return (
    cislo(aktivnyVariant?.horizont) +
    (
      aktivnyVariant
        ?.dodatocneZhodnocovanieZapnute
        ? cislo(
            aktivnyVariant
              ?.dodatocneZhodnocovanieRoky
          )
        : 0
    )
  );
}

function vypocitajVazeneZhodnotenieVlastnejVolby(
  zadaneRiadky
) {
  if (
    zadaneRiadky.length === 0 ||
    !zadaneRiadky.every(
      (riadok) =>
        riadok.priemerneZhodnotenie !==
          "" &&
        Number.isFinite(
          Number(
            riadok.priemerneZhodnotenie
          )
        )
    )
  ) {
    return null;
  }

  const sucetPodielov =
    zadaneRiadky.reduce(
      (spolu, riadok) =>
        spolu + cislo(riadok.podiel),
      0
    );

  if (sucetPodielov <= 0) {
    return null;
  }

  return zadaneRiadky.reduce(
    (spolu, riadok) =>
      spolu +
      cislo(riadok.podiel) *
        cislo(
          riadok.priemerneZhodnotenie
        ),
    0
  ) / sucetPodielov;
}

const formatujKompaktnuMenu = (
  hodnota
) =>
  new Intl.NumberFormat(
    "sk-SK",
    {
      style: "currency",
      currency: "EUR",
      notation: "compact",
      maximumFractionDigits: 1,
    }
  ).format(cislo(hodnota));

const formatujPercento = (hodnota) =>
  cislo(hodnota).toLocaleString(
    "sk-SK",
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    }
  );

function vytvorDomenu(odkaz) {
  if (!odkaz) return "";

  try {
    return new URL(odkaz).hostname;
  } catch {
    return "";
  }
}

function vytvorPolozkyZlozenia(
  zlozenieAktiv
) {
  if (
    !zlozenieAktiv ||
    zlozenieAktiv.variabilne
  ) {
    return [];
  }

  return TRIEDY_AKTIV
    .map((trieda) => ({
      ...trieda,
      podiel: cislo(
        zlozenieAktiv[trieda.kluc]
      ),
    }))
    .filter(
      (trieda) => trieda.podiel > 0
    );
}

function vypocitajVycislenieTipu(
  polozka,
  aktivnyVariant
) {
  const zmeny =
    polozka?.vycislenie?.zmeny;

  const povodnyVysledok =
    aktivnyVariant?.vysledok;

  if (
    !zmeny ||
    !povodnyVysledok
  ) {
    return null;
  }

  try {
    const alternativnyVysledok =
      vypocitajInvesticnuKalkulacku({
        ...aktivnyVariant,
        ...zmeny,
      });

    const povodnaHodnota = cislo(
      povodnyVysledok
        .konecnaHodnotaPoDani
    );

    const alternativnaHodnota = cislo(
      alternativnyVysledok
        .konecnaHodnotaPoDani
    );

    const rozdielHodnoty =
      alternativnaHodnota -
      povodnaHodnota;

    if (
      povodnaHodnota <= 0 ||
      rozdielHodnoty <= 0
    ) {
      return null;
    }

    return {
      rozdielHodnoty,

      rozdielPercent:
        (
          rozdielHodnoty /
          povodnaHodnota
        ) * 100,
    };
  } catch {
    return null;
  }
}

function DonutZlozenieAktiv({
  zlozenieAktiv,
  chyba = "",
}) {
  if (chyba) {
    return (
      <div
        className="invest-odporucania-vystup__zlozenie-prazdne is-error"
        role="alert"
      >
        {chyba}
      </div>
    );
  }

  const polozky =
    vytvorPolozkyZlozenia(
      zlozenieAktiv
    );

  if (polozky.length === 0) {
    return (
      <div className="invest-odporucania-vystup__zlozenie-prazdne">
        Zloženie aktív nie je pevne
        určené.
      </div>
    );
  }

  let predchadzajuciPodiel = 0;

  return (
    <div className="invest-odporucania-vystup__zlozenie">
      <div className="invest-odporucania-vystup__donut">
        <svg
          viewBox="0 0 100 100"
          role="img"
          aria-label="Zloženie tried aktív"
        >
          <circle
            className="invest-odporucania-vystup__donut-bg"
            cx="50"
            cy="50"
            r="38"
            pathLength="100"
          />

          {polozky.map((polozka) => {
            const offset =
              predchadzajuciPodiel;

            predchadzajuciPodiel +=
              polozka.podiel;

            return (
              <circle
                key={polozka.kluc}
                className="invest-odporucania-vystup__donut-segment"
                cx="50"
                cy="50"
                r="38"
                pathLength="100"
                stroke={polozka.farba}
                strokeDasharray={
                  `${polozka.podiel} ${
                    100 -
                    polozka.podiel
                  }`
                }
                strokeDashoffset={
                  -offset
                }
              />
            );
          })}

          <text
            x="50"
            y="48"
            textAnchor="middle"
            className="invest-odporucania-vystup__donut-label"
          >
            Triedy
          </text>

          <text
            x="50"
            y="59"
            textAnchor="middle"
            className="invest-odporucania-vystup__donut-value"
          >
            100 %
          </text>
        </svg>
      </div>

      <div className="invest-odporucania-vystup__legenda">
        {polozky.map((polozka) => (
          <div
            key={polozka.kluc}
            className="invest-odporucania-vystup__legenda-riadok"
          >
            <span
              style={{
                background:
                  polozka.farba,
              }}
            />

            <small>
              {polozka.nazov}
            </small>

            <strong>
              {formatujPercento(
                polozka.podiel
              )}{" "}
              %
            </strong>
          </div>
        ))}
      </div>
    </div>
  );
}

function JedenProdukt({
  produkt,
  aktivnyVariant,
  analyzaVyberu,
}) {
  const celkovyHorizont =
    zistiCelkovyHorizont(
      aktivnyVariant
    );

  const sri = Number(produkt?.SRI);

  const mesacnyVklad = cislo(
    aktivnyVariant?.mesacnyVklad
  );

  const jednorazovyVklad = cislo(
    aktivnyVariant?.jednorazovyVklad
  );

  const jednorazovyPrivklad =
    aktivnyVariant
      ?.jednorazovyPrivkladZapnuty
      ? cislo(
          aktivnyVariant
            .jednorazovyPrivklad
        )
      : 0;

  const spolocnostOdkaz =
    produkt?.spolocnost?.odkaz;

  const produktOdkaz =
    produkt?.nazovProduktu?.odkaz;

  const domena =
    vytvorDomenu(
      spolocnostOdkaz
    );

  const zlozenieAktiv =
    analyzaVyberu?.data
      ?.zlozenieAktiv ||
    produkt?.zlozenieAktiv;

  const miniTip =
    analyzaVyberu?.data?.miniTip;

  return (
    <div
      className={`invest-odporucania-vystup__jeden-produkt ${
        miniTip
          ? "ma-mini-tip"
          : ""
      }`}
    >
      <div className="invest-odporucania-vystup__produkt-info">
        <span className="invest-odporucania-vystup__spolocnost">
          {produkt?.spolocnost?.nazov}
        </span>

        <strong className="invest-odporucania-vystup__nazov-produktu">
          {produkt?.nazovProduktu?.nazov}
        </strong>

        <div className="invest-odporucania-vystup__produkt-meta">
          <div>
            {celkovyHorizont > 0 && (
              <span>
                Horizont:{" "}
                {formatujPercento(
                  celkovyHorizont
                )}{" "}
                r.
              </span>
            )}

            {Number.isFinite(sri) &&
              sri >= 1 &&
              sri <= 7 && (
                <span>
                  SRI: {sri}
                </span>
              )}

            {mesacnyVklad > 0 && (
              <span>
                Mesačne:{" "}
                {formatujMena(
                  mesacnyVklad
                )}{" "}
                €
              </span>
            )}
          </div>

          {(jednorazovyVklad > 0 ||
            jednorazovyPrivklad > 0) && (
            <div>
              {jednorazovyVklad > 0 && (
                <span>
                  Jednorazovo:{" "}
                  {formatujMena(
                    jednorazovyVklad
                  )}{" "}
                  €
                </span>
              )}

              {jednorazovyPrivklad > 0 && (
                <span>
                  Prívklad:{" "}
                  {formatujMena(
                    jednorazovyPrivklad
                  )}{" "}
                  €
                </span>
              )}
            </div>
          )}
        </div>

        {spolocnostOdkaz &&
          domena && (
            <a
              className="invest-odporucania-vystup__web"
              href={spolocnostOdkaz}
              target="_blank"
              rel="noopener noreferrer"
            >
              {domena}
            </a>
          )}

        {produktOdkaz && (
          <a
            className="action-btn invest-odporucania-vystup__zalozit"
            href={produktOdkaz}
            target="_blank"
            rel="noopener noreferrer"
          >
            Založiť
          </a>
        )}
      </div>

      <div className="invest-odporucania-vystup__produkt-graf">
        <DonutZlozenieAktiv
          zlozenieAktiv={
            zlozenieAktiv
          }
        />
      </div>

      {miniTip && (
        <div className="invest-odporucania-vystup__mini-tip">
          <strong>
            💡 FinCloud Tip:
          </strong>

          <span>
            {miniTip.sprava}
          </span>
        </div>
      )}
    </div>
  );
}

function ViacProduktov({
  produkty,
  maVlastnuVolbu,
  vlastnaVolbaProdukt,
  vahyRieseni,
  aktivnyVariant,
  analyzaVyberu,
  onUpravitVahy,
}) {
  const polozky = [
    ...produkty.map(
      (produkt) => ({
        kluc:
          vytvorKlucProduktu(
            produkt.kod
          ),

        spolocnost:
          produkt.spolocnost
            ?.nazov || "",

        nazov:
          produkt.nazovProduktu
            ?.nazov ||
          produkt.kod,
        odkaz:
          produkt.nazovProduktu
            ?.odkaz,
        sri: Number(produkt?.SRI),
        vaha: cislo(
          vahyRieseni[
            vytvorKlucProduktu(
              produkt.kod
            )
          ]
        ),
      })
    ),

    ...(
      maVlastnuVolbu
        ? [
            {
              kluc:
                VLASTNA_VOLBA_KLUC,

              spolocnost:
                vlastnaVolbaProdukt
                  ?.spolocnost
                  ?.nazov || "",

              nazov:
                vlastnaVolbaProdukt
                  ?.nazovProduktu
                  ?.nazov ||
                "Individuálny výber fondov",

              odkaz:
                vlastnaVolbaProdukt
                  ?.nazovProduktu
                  ?.odkaz,

              sri: Number(
                vlastnaVolbaProdukt
                  ?.SRI
              ),
              vaha: cislo(
                vahyRieseni[
                  VLASTNA_VOLBA_KLUC
                ]
              ),
            },
          ]
        : []
    ),
  ];

  const mesacneSumy =
    rozdelSumuPodlaVah(
      polozky,
      aktivnyVariant
        ?.mesacnyVklad
    );

  const jednorazoveSumy =
    rozdelSumuPodlaVah(
      polozky,
      aktivnyVariant
        ?.jednorazovyVklad
    );

  const miniTip =
    analyzaVyberu?.data
      ?.miniTip;

  const celkovyHorizont =
    zistiCelkovyHorizont(
      aktivnyVariant
    );

  return (
    <div
      className={
        miniTip
          ? "invest-odporucania-vystup__viac-produktov ma-mini-tip"
          : "invest-odporucania-vystup__viac-produktov"
      }
    >
      <div className="invest-odporucania-vystup__viac-zoznam">
        <button
          type="button"
          className="invest-odporucania-vystup__upravit-vahy"
          onClick={
            onUpravitVahy
          }
        >
          Upraviť váhy
        </button>

        {polozky.map(
          (polozka) => (
            <div
              key={
                polozka.kluc
              }
              className="invest-odporucania-vystup__viac-polozka"
            >
              {polozka.spolocnost && (
                <span className="invest-odporucania-vystup__spolocnost">
                  {
                    polozka.spolocnost
                  }
                </span>
              )}

              <strong className="invest-odporucania-vystup__nazov-produktu">
                {polozka.nazov}
              </strong>

              <div className="invest-odporucania-vystup__produkt-meta invest-odporucania-vystup__viac-meta">
                <div>
                  {celkovyHorizont > 0 && (
                    <span>
                      Horizont:{" "}
                      {formatujPercento(
                        celkovyHorizont
                      )}{" "}
                      r.
                    </span>
                  )}

                  {Number.isFinite(
                    polozka.sri
                  ) &&
                    polozka.sri >= 1 &&
                    polozka.sri <= 7 && (
                      <span>
                        SRI: {polozka.sri}
                      </span>
                    )}

                  <span>
                    Váha:{" "}
                    {formatujPercento(
                      polozka.vaha
                    )}{" "}
                    %
                  </span>

                  {cislo(
                    aktivnyVariant
                      ?.mesacnyVklad
                  ) > 0 && (
                    <span>
                      Mesačne:{" "}
                      {formatujRozdelenuMenu(
                        mesacneSumy[
                          polozka.kluc
                        ]
                      )}{" "}
                      €
                    </span>
                  )}

                  {cislo(
                    aktivnyVariant
                      ?.jednorazovyVklad
                  ) > 0 && (
                    <span>
                      Jednorazovo:{" "}
                      {formatujRozdelenuMenu(
                        jednorazoveSumy[
                          polozka.kluc
                        ]
                      )}{" "}
                      €
                    </span>
                  )}

                  {polozka.odkaz && (
                    <a
                      className="invest-odporucania-vystup__zalozit-link"
                      href={polozka.odkaz}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Založiť
                    </a>
                  )}
                </div>
              </div>
            </div>
          )
        )}
      </div>

      <div className="invest-odporucania-vystup__produkt-graf">
        <DonutZlozenieAktiv
          zlozenieAktiv={
            analyzaVyberu
              ?.data
              ?.zlozenieAktiv
          }
          chyba={
            analyzaVyberu
              ?.chyba || ""
          }
        />
      </div>

      {miniTip && (
        <div className="invest-odporucania-vystup__mini-tip">
          <strong>
            💡 FinCloud Tip:
          </strong>

          <span>
            {miniTip.sprava}
          </span>
        </div>
      )}
    </div>
  );
}

function VlastnaVolba({
  vlastnaVolbaProdukt,
  zadaneRiadky,
  aktivnyVariant,
  analyzaVyberu,
}) {
  const miniTip =
    vlastnaVolbaProdukt
      ? null
      : analyzaVyberu?.data
          ?.miniTip;

  const celkovyHorizont =
    zistiCelkovyHorizont(
      aktivnyVariant
    );

  const vazeneZhodnotenie =
    vypocitajVazeneZhodnotenieVlastnejVolby(
      zadaneRiadky
    );

  const mesacnyVklad = cislo(
    aktivnyVariant?.mesacnyVklad
  );

  const jednorazovyVklad = cislo(
    aktivnyVariant?.jednorazovyVklad
  );

  const produktOdkaz =
    vlastnaVolbaProdukt
      ?.nazovProduktu?.odkaz;

  return (
    <div
      className={
        miniTip
          ? "invest-odporucania-vystup__viac-produktov ma-mini-tip"
          : "invest-odporucania-vystup__viac-produktov"
      }
    >
      <div className="invest-odporucania-vystup__vlastna-volba">
        {vlastnaVolbaProdukt
          ?.spolocnost?.nazov && (
          <span className="invest-odporucania-vystup__spolocnost">
            {
              vlastnaVolbaProdukt
                .spolocnost.nazov
            }
          </span>
        )}

        <strong className="invest-odporucania-vystup__nazov-produktu">
          {vlastnaVolbaProdukt
            ?.nazovProduktu
            ?.nazov ||
            "Individuálny výber fondov"}
        </strong>

        <div className="invest-odporucania-vystup__fondy">
          {zadaneRiadky.map(
            (riadok) => (
              <div
                key={riadok.id}
                className="invest-odporucania-vystup__fond"
              >
                <span>
                  {riadok.nazov}
                </span>

                <strong>
                  {formatujPercento(
                    riadok.podiel
                  )}{" "}
                  %
                </strong>
              </div>
            )
          )}
        </div>

        <div className="invest-odporucania-vystup__produkt-meta invest-odporucania-vystup__vlastna-meta">
          <div>
            {celkovyHorizont > 0 && (
              <span>
                Horizont:{" "}
                {formatujPercento(
                  celkovyHorizont
                )}{" "}
                r.
              </span>
            )}

            {vazeneZhodnotenie !==
              null && (
              <span>
                Ø p.a.:{" "}
                {formatujPercento(
                  vazeneZhodnotenie
                )}{" "}
                %
              </span>
            )}

            {mesacnyVklad > 0 && (
              <span>
                Mesačne:{" "}
                {formatujMena(
                  mesacnyVklad
                )}{" "}
                €
              </span>
            )}
          </div>

          {jednorazovyVklad > 0 && (
            <div>
              <span>
                Jednorazovo:{" "}
                {formatujMena(
                  jednorazovyVklad
                )}{" "}
                €
              </span>
            </div>
          )}
        </div>

        {produktOdkaz && (
          <a
            className="action-btn invest-odporucania-vystup__zalozit"
            href={produktOdkaz}
            target="_blank"
            rel="noopener noreferrer"
          >
            Založiť
          </a>
        )}
      </div>

      <div className="invest-odporucania-vystup__produkt-graf">
        <DonutZlozenieAktiv
          zlozenieAktiv={
            analyzaVyberu
              ?.data
              ?.zlozenieAktiv
          }
        />
      </div>

      {miniTip && (
        <div className="invest-odporucania-vystup__mini-tip">
          <strong>
            💡 FinCloud Tip:
          </strong>

          <span>
            {miniTip.sprava}
          </span>
        </div>
      )}
    </div>
  );
}

export default function InvesticneOdporucaniaVystupKarta({
  variantKluc,
  stav,
  zvoleneProdukty,
  maProduktovyVyber,
  maVlastnuVolbu,
  vlastnaVolbaJeVybrana,
  vlastnaVolbaProdukt,
  vahyRieseni,
  onUpravitVahy,
  zadaneRiadky,
  aktivnyVariant,
  analyzaVyberu,
}) {
  const upozornenia = Array.isArray(
    stav.data?.upozornenia
  )
    ? stav.data.upozornenia
    : [];

  const tipy = Array.isArray(
    stav.data?.tipy
  )
    ? stav.data.tipy
    : [];

  const najblizsiProduktPoUprave =
    Array.isArray(
      stav.data?.vhodnePoUprave
    )
      ? stav.data.vhodnePoUprave.find(
          (produkt) =>
            Array.isArray(
              produkt?.potrebneUpravy
            ) &&
            produkt.potrebneUpravy
              .length === 1
        ) || null
      : null;

  const pocetVybranychRieseni =
    zvoleneProdukty.length +
    (
      vlastnaVolbaJeVybrana
        ? 1
        : 0
    );

  const vlastnaVolbaJePripravena =
    !vlastnaVolbaJeVybrana ||
    maVlastnuVolbu;

  const jedinyProdukt =
    maProduktovyVyber &&
    zvoleneProdukty.length === 1 &&
    !vlastnaVolbaJeVybrana
      ? zvoleneProdukty[0]
      : null;

  const jeViacProduktov =
    pocetVybranychRieseni >= 2 &&
    vlastnaVolbaJePripravena;

  const jeIbaVlastnaVolba =
    maVlastnuVolbu &&
    zvoleneProdukty.length === 0;

  return (
    <div className="card-section card-section--invest-odporucania card-section--invest-odporucania-vystup">
      <div className="invest-odporucania-vystup__head">
        <h2>
          Návrh investičného riešenia
        </h2>

        <span>
          Variant{" "}
          {variantKluc === "variant2"
            ? "2"
            : "1"}
        </span>
      </div>

      <div className="invest-odporucania-vystup__scroll">
        {jedinyProdukt && (
          <JedenProdukt
            produkt={jedinyProdukt}
            aktivnyVariant={
              aktivnyVariant
            }
            analyzaVyberu={
              analyzaVyberu
            }
          />
        )}

        {jeViacProduktov && (
          <ViacProduktov
            produkty={
              zvoleneProdukty
            }
            maVlastnuVolbu={
              maVlastnuVolbu
            }
            vlastnaVolbaProdukt={
              vlastnaVolbaProdukt
            }
            vahyRieseni={
              vahyRieseni
            }
            aktivnyVariant={
              aktivnyVariant
            }
            analyzaVyberu={
              analyzaVyberu
            }
            onUpravitVahy={
              onUpravitVahy
            }
          />
        )}

        {jeIbaVlastnaVolba && (
          <VlastnaVolba
            vlastnaVolbaProdukt={
              vlastnaVolbaProdukt
            }
            zadaneRiadky={
              zadaneRiadky
            }
            aktivnyVariant={
              aktivnyVariant
            }
            analyzaVyberu={
              analyzaVyberu
            }
          />
        )}

        {vlastnaVolbaJeVybrana &&
          !maVlastnuVolbu && (
            <div className="invest-odporucania-stav">
              Vyplňte vlastnú voľbu a
              nastavte súčet podielov na
              100 %.
            </div>
          )}

        {!maProduktovyVyber &&
          !vlastnaVolbaJeVybrana && (
            <>
              {stav.nacitavaSa &&
                !stav.data && (
                  <div className="invest-odporucania-stav">
                    Pripravujem tipy…
                  </div>
                )}

              {stav.chyba && (
                <div className="inv-hint pp-hint error">
                  {stav.chyba}
                </div>
              )}

              {!stav.chyba &&
                upozornenia.map(
                  (polozka) => (
                    <div
                      key={polozka.kod}
                      className="invest-odporucania-vystup__tip is-warning"
                    >
                      <strong>
                        Upozornenie
                      </strong>

                      <span>
                        {polozka.sprava}
                      </span>
                    </div>
                  )
                )}

              {!stav.chyba &&
                tipy.map((polozka) => {
                  const vycislenie =
                    vypocitajVycislenieTipu(
                      polozka,
                      aktivnyVariant
                    );

                  return (
                    <div
                      key={polozka.kod}
                      className="invest-odporucania-vystup__tip"
                    >
                      <strong>
                        💡 FinCloud Tip:
                      </strong>

                      <span>
                        {polozka.sprava}

                        {vycislenie
                          ? ` Hodnota investície by bola vyššia približne o ${formatujKompaktnuMenu(
                              vycislenie
                                .rozdielHodnoty
                            )} (+${formatujPercento(
                              vycislenie
                                .rozdielPercent
                            )} %).`
                          : ""}
                      </span>
                    </div>
                  );
                })}

              {!stav.chyba &&
                najblizsiProduktPoUprave && (
                  <div className="invest-odporucania-vystup__tip is-warning is-adjustment">
                    <strong>
                      {[
                        najblizsiProduktPoUprave
                          .spolocnost?.nazov,
                        najblizsiProduktPoUprave
                          .nazovProduktu?.nazov,
                      ]
                        .filter(Boolean)
                        .join(" – ")}
                    </strong>

                    <span>
                      Pre jeho použitie upravte
                      vstupy:{" "}
                      {najblizsiProduktPoUprave
                        .potrebneUpravy
                        .map(
                          (uprava) =>
                            uprava.sprava
                        )
                        .filter(Boolean)
                        .join(" ")}
                    </span>
                  </div>
                )}

              {!stav.chyba &&
                !stav.nacitavaSa &&
                upozornenia.length === 0 &&
                tipy.length === 0 &&
                !najblizsiProduktPoUprave && (
                  <div className="invest-odporucania-stav">
                    Vyberte odporúčaný
                    produkt alebo vyplňte
                    vlastnú voľbu.
                  </div>
                )}
            </>
          )}
      </div>
    </div>
  );
}